import React from 'react';
import {
    Card,
    Thumbnail,
    Stack,
    TextStyle
} from '@shopify/polaris';
import { ToGenieTag } from "../../components/GenieTag";


export function TagRulePreviewArea(props) {

    var resourcePreviewGenerator = renderProductTagsPreview;

    if (props.previewType === "ProductMetafield") {
        resourcePreviewGenerator = renderProductMetafieldPreview;
    }

    if (props.previewType === "ProductVariantMetafield") {
        resourcePreviewGenerator = renderProductVariantMetafieldsPreview;
    }

    var previewItems = props.resources.map(_ => resourcePreviewGenerator(_, props.resourcePreviews));

    return (
        <React.Fragment>
            {previewItems}
        </React.Fragment>
    );
}

function renderProductTagsPreview(resource, resourcePreviews) {

    const preview = resourcePreviews.filter(_ => _.id === resource.id)[0];
    let tags = null;

    if (preview != null) {

        tags = ToGenieTag(preview.tags);
    }

    return <div>
        <Stack alignment='center'>
            <Stack.Item>
                <Thumbnail source={resource.image} alt="image" size="small" />
            </Stack.Item>
            <Stack.Item>
                <TextStyle variation="strong">{resource.title}</TextStyle>
            </Stack.Item>
        </Stack>
        <br />
        <Stack spacing="tight" distribution="leading" alignment="leading">
            {tags}
        </Stack>
        <br />
        <br />
    </div>
}

function renderProductMetafieldPreview(resource, resourcePreviews) {

    const preview = resourcePreviews.filter(_ => _.id === resource.id)[0];
    let metafieldValueElements = [];

    if (preview != null) {

        metafieldValueElements = preview.metafieldValues.map(_ => {

            let metafieldValue = _.value;

            if (metafieldValue == null) {
                metafieldValue = "No value";
            }

            return <Stack alignment='center'>
                <Stack.Item>
                    <TextStyle variation="strong">{_.namespaceAndKey}:</TextStyle>
                </Stack.Item>
                <Stack.Item>{metafieldValue}</Stack.Item>
            </Stack>
        });
    }

    return <div>
        <Stack alignment='center'>
            <Stack.Item>
                <Thumbnail source={resource.image} alt="image" size="small" />
            </Stack.Item>
            <Stack.Item>
                <TextStyle variation="strong">{resource.title}</TextStyle>
            </Stack.Item>
        </Stack>
        <br />
        <p><b>Metafields:</b></p>
        {metafieldValueElements}
        <br />
    </div>
}

function renderProductVariantMetafieldsPreview(resource, resourcePreviews) {

    const preview = resourcePreviews.filter(_ => _.id === resource.id)[0];
    let variantElements = [];

    if (preview != null) {

        variantElements = preview.variantPreviews.map(_ => {

            let metafieldValueElements = _.metafieldValuePreviews.map(__ => renderVariantMetafielPreviews(__));

            return <div>
                <p><b>{_.variantTitle}</b></p>
                {metafieldValueElements}
                <br />
            </div>;
        });
    }

    return <Card.Section>
        <Stack alignment='center'>
            <Stack.Item>
                <Thumbnail source={resource.image} alt="image" size="small" />
            </Stack.Item>
            <Stack.Item>
                <TextStyle variation="strong">{resource.title}</TextStyle>
            </Stack.Item>
        </Stack>
        <br />
        <Stack distribution="trailing">
            <p>Variants</p>
        </Stack>
        {variantElements}
    </Card.Section>
}

function renderVariantMetafielPreviews(preview) {
    let metafieldValue = preview.value;

    if (metafieldValue == null) {
        metafieldValue = "No value";
    }

    return <Stack alignment='center'>
        <Stack.Item>
            <TextStyle variation="strong">{preview.namespaceAndKey}:</TextStyle>
        </Stack.Item>
        <Stack.Item>{metafieldValue}</Stack.Item>
    </Stack>
}